module.exports = __webpack_public_path__ + "geldpen_ill.jpg?7df6da0c8fbdcf019789b9c538fb51dc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placeholders/geldpen_ill.jpg
// module id = 608
// module chunks = 0